import { adminNoticePageState } from "@/atoms/notice/admin-notice-page-state";
import { toastState } from "@/atoms/system/toast-state";
import { ButtonColor } from "@/common/enum/button-color";
import { noticeService } from "@/services/notice-service";
import { Button, Modal } from "flowbite-react";
import React from "react";
import { useSetRecoilState } from "recoil";
import { RedExclamationCircleIcon } from "../icon/RedExclamationCircleIcon";
import { Body16Regular } from "../typography/Body16Regular";

interface Props {
  noticeIds: number[];
  closeModal: () => void;
  clearSelectedNotice: () => void;
  onSuccess: () => void;
}

export const DeleteBulkAdminNoticeModal: React.FC<Props> = ({
  noticeIds,
  closeModal,
  clearSelectedNotice,
  onSuccess,
}) => {
  const setNoticePage = useSetRecoilState(adminNoticePageState);
  const setToast = useSetRecoilState(toastState);

  const handleSubmit = async () => {
    try {
      const response = await noticeService.deleteBulk({ ids: noticeIds });
      if (!response.ok) {
        return;
      }
      setNoticePage((prev) => ({
        ...prev,
        contents: prev.contents.filter(
          (content) => !noticeIds.includes(content.id)
        ),
      }));
      setToast({
        show: true,
        messages: [`게시글이 삭제되었습니다.`],
      });
      onSuccess();
      clearSelectedNotice();
      closeModal();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Modal size="md" show={true} onClose={closeModal}>
      <Modal.Header className="pt-[10px] px-[10px] h-[36px] border-none"></Modal.Header>
      <Modal.Body className="p-0">
        <div className="flex flex-col items-center box-border py-[20px] gap-[20px]">
          <div className="w-[42px] h-[42px] flex items-center justify-center">
            <RedExclamationCircleIcon size={35} />
          </div>
          <div className="flex flex-col items-center">
            <div>
              <Body16Regular className="text-semantic-text-secondary">
                게시글을 삭제하시겠어요?
              </Body16Regular>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="pt-0 border-none">
        <div className="flex gap-[16px] items-center justify-center w-full">
          <Button color={ButtonColor.TRANSPARENT_OUTLINE} onClick={closeModal}>
            취소하기
          </Button>
          <Button color={ButtonColor.RED} onClick={handleSubmit}>
            삭제하기
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
